import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import Task from '../../interfaces/Task.interface';

const selectTasks = (state: RootState) => state.tasks;

export const selectAllTasks = () => createSelector(
  [selectTasks],
  (tasks) => {
    return tasks.normalizedTasks;
  }
);

export const selectTaskById = (id: number) => createSelector(
  [selectTasks],
  (tasks) => {
    return tasks.normalizedTasks.find((task: Task) => task.id === id);
  }
);

export const selectTasksByParentId = (parentTaskId: number | null) => createSelector(
  [selectTasks],
  (tasks) => {
    return tasks.normalizedTasks.filter((task: Task) => task.parentTaskId === parentTaskId);
  }
);

export const selectUncompleteTasksByParentId = (parentTaskId: number | null) => createSelector(
  [selectTasks],
  (tasks) => {
    return tasks.normalizedTasks.filter((task: Task) => {
      return task.parentTaskId === parentTaskId && task.completed === false;
    })
  }
);

export const selectUncompleteTasks = () => createSelector(
  [selectTasks],
  (tasks) => {
    return tasks.normalizedTasks.filter((task: Task) => {
      return task.completed === false;
    })
  }
);

export const selectCompleteTasksByParentId = (parentTaskId: number | null) => createSelector(
  [selectTasks],
  (tasks) => {
    return tasks.normalizedTasks.filter((task: Task) => {
      return task.parentTaskId === parentTaskId && task.completed === true;
    })
  }
);

export const selectCompleteTasks = () => createSelector(
  [selectTasks],
  (tasks) => {
    return tasks.normalizedTasks.filter((task: Task) => {
      return task.completed === true;
    })
  }
);
